import { render, staticRenderFns } from "./UnicoIntegration.vue?vue&type=template&id=c6fb740c&scoped=true&"
import script from "./UnicoIntegration.vue?vue&type=script&lang=js&"
export * from "./UnicoIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fb740c",
  null
  
)

export default component.exports